import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classnames from 'clsx';

import { InsuranceProviders } from '../../../enums/insurance-providers';
import { useHasUserAcceptedInsuranceTerms } from '../../../services/insurance-terms-service';

import { InsuranceBody } from './body';
import { InsuranceTermsLink } from '../../../insurance/terms-link';
import { InsuranceKBLink } from '../../../insurance/kb-link';
import { EventSourceStrings } from '../../../tracking/tracking-constants';
import { InteractablePopover } from 'ui-components/components/interactable-popover';

import style from './style.module.css';
import { disclaimerMessages, parcelGuardTooltipMessages } from './messages';

export const insuranceProviderIdsWithTerms = [
  InsuranceProviders.Shipsurance.insuranceProviderId,
  InsuranceProviders.XCover.insuranceProviderId,
  InsuranceProviders.ParcelGuard.insuranceProviderId,
];

const title = <FormattedMessage {...parcelGuardTooltipMessages.about} />;

export const InsuranceTerms = ({ className, selectedInsuranceOptionId }) => {
  const hasAcceptedInsuranceTerms = useHasUserAcceptedInsuranceTerms(selectedInsuranceOptionId);

  if (!insuranceProviderIdsWithTerms.includes(selectedInsuranceOptionId)) {
    return null;
  }

  if (selectedInsuranceOptionId === InsuranceProviders.Shipsurance.insuranceProviderId && !hasAcceptedInsuranceTerms) {
    return null;
  }

  return (
    <div className={classnames(style['terms-container'], className)}>
      <FormattedMessage
        {...disclaimerMessages[selectedInsuranceOptionId]}
        values={{
          a: (chunks) => (
            <InsuranceTermsLink insuranceProviderId={selectedInsuranceOptionId} source={EventSourceStrings.CSW_INSURANCE_FIELD}>
              {chunks}
            </InsuranceTermsLink>
          ),
          helpArticleLink: (chunks) => <InsuranceKBLink insuranceProviderId={selectedInsuranceOptionId}>{chunks}</InsuranceKBLink>,
          popover: (chunks) => (
            <InteractablePopover
              ignoreTooltip
              popoverBody={<InsuranceBody selectedInsuranceOptionId={selectedInsuranceOptionId} />}
              targetClassName={classnames(style['popover-target'], style.terms)}
              title={title}
            >
              <button className={style['button-link']}>{chunks}</button>
            </InteractablePopover>
          ),
        }}
      />
    </div>
  );
};

InsuranceTerms.propTypes = {
  className: PropTypes.string,
  selectedInsuranceOptionId: PropTypes.string.isRequired,
};
